import React, { useState, useReducer } from 'react'
import moment from 'moment'
import { Checkbox, Select } from 'components/forms'
import { useTranslation } from 'react-i18next'

import { FormCol, FormRow } from 'style/styled'
import Divider from 'components/Divider'
import Button from 'components/Button'
import { ContentBlock, ExpandableBlocks } from 'components/ContentBlock'
import ProfileSettings from 'components/ProfileSettings/ProfileSettings'
import { FormContainer } from 'components/ProfileSettings/styled'

import ShopStatisticTable from './ShopStatisticTable'
import { DatePeriod } from '../filterFragments'
import { filterReducer } from '../filterFragments'
import { useStatisticsData } from '../helpers'
import { getShopStatisticsData, initShopStatistics } from '../../gql/getShopStatistics'

export default function ShopStatisticFilter() {
	const [t] = useTranslation()
	const [expandedId, setExpandedId] = useState(null)
	const [settingsData, setSettingsData] = useState({})
	const statisticsDataReceived = useStatisticsData({
		getQuery: getShopStatisticsData,
		initQuery: initShopStatistics
	})
	const { data = [], loading, called, getStatistics, status } = statisticsDataReceived

	const defaultFilter = {
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString(),
		groupBy: 'SHOP',
		isSalesGroup: false
	}
	const [filter, dispatchFilter] = useReducer(filterReducer, defaultFilter)

	const handleSetFilter = () => {
		const { isSalesGroup, ...filterParam } = filter
		getStatistics({ variables: { params: filterParam } })
		setExpandedId('1')
		const isGroups = settingsData?.columns && settingsData?.columns.some(item => item?.groupIndex >= 0)
		if(!isGroups && filter.groupBy === 'SHOP_DAYS') {
			setSettingsData({ columns: [{ dataField: 'name', groupIndex: 0 }] })
		}
	}

	const handleSetProfileSettings = settings => {
		const filterToSet = settings ? settings : defaultFilter
		dispatchFilter({
			type: 'hydrateFromSaved',
			value: filterToSet
		})
	}
	return (
		<>
			<ExpandableBlocks expandedId={expandedId} onExpand={setExpandedId}>
				<ContentBlock blockId='0' startExpanded={!called} label={t('common.strings.settings')}>
					<FormRow>
						<FormCol xs style={{ marginLeft: -20 }}>
							<ProfileSettings filters={filter} onUpdateFilters={handleSetProfileSettings} nameLocalStorage={'statisticsProfiles'}/>
						</FormCol>
					</FormRow>
					<FormRow>
						<FormCol xs>
							<Select
								noForm
								label={t('statistic_section.strings.grouped_by')}
								value={filter.groupBy}
								options={[
									{ label: t('common.strings.branch'), value: 'SHOP' },
									{ label: `${t('common.strings.branch')}-${t('common.dates.days')}`, value: 'SHOP_DAYS' }
								]}
								onChange={({ value }) => dispatchFilter({ type: 'groupBy', value })}
							/>
						</FormCol>
						<DatePeriod
							value={{ fromDateTime: filter.from, toDateTime: filter.to }}
							onChange={value => dispatchFilter({ value, type: 'datePeriod' })}
							label={t('statistic_section.strings.date')}
							labelPeriod={{
								from: `${t('statistic_section.strings.date')} ${t('common.strings.from').toLowerCase()}`,
								to: `${t('statistic_section.strings.date')} ${t('common.strings.to').toLowerCase()}`
							}}
						/>
						
						<FormContainer>
							<Checkbox
								noForm
								checked={filter.isSalesGroup}
								onChange={(e) => dispatchFilter({ type: 'isSalesGroup', value: e.target.checked })}
								label={t('statistic_section.fields.article_groups')}
							/>
						</FormContainer>
					</FormRow>
					<FormRow>
						<FormCol xs>
							<Button text={t('common.buttons.calculate')} onClick={handleSetFilter}/>
						</FormCol>
					</FormRow>
					<Divider />
				</ContentBlock>
			</ExpandableBlocks>
			<ShopStatisticTable
				data={data}
				loading={loading}
				called={called}
				filter={filter}
				status={status}
				settings={settingsData}
				onSaveSettings={setSettingsData}
			/>
		</>
	)
}
